import { DeleteOutlined, EllipsisOutlined } from "@ant-design/icons";
import { Button, Dropdown, MenuProps } from "antd";
import * as React from "react";
import { DeleteConfirm } from "src/components/DeleteConfirm";

type PropsValueCatalogActions = {
  onDelete?: () => Promise<void>;
};

export const ValueCatalogActions: React.FC<PropsValueCatalogActions> = (
  props,
) => {
  const { onDelete } = props;
  const [deleting, setDeleting] = React.useState(false);

  const items: MenuProps["items"] = [
    {
      key: "delete",
      label: "Удалить",
      icon: <DeleteOutlined />,
      danger: true,
      onClick: () => setDeleting(true),
    },
  ];
  if (!onDelete) return null;
  return (
    <>
      <Dropdown menu={{ items }}>
        <Button icon={<EllipsisOutlined />} />
      </Dropdown>
      <DeleteConfirm
        open={deleting}
        close={() => setDeleting(false)}
        task={onDelete}
        content="Удалить каталог значений?"
      />
    </>
  );
};
